import React, {useEffect, useState} from 'react';
import { useForm } from 'react-hook-form';
import { statesAbbr } from "../../global/utils";
import { useStyles as classes } from "../../styles/styles";
import { validateEpRequest, getEpRequest } from "./optionFunctions";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import { PatternFormat } from "react-number-format";

const EpPlea = (props) => {
    const requestData = props.requestData;
    const setData = props.setData;
    const setErrorMessage = props.setErrorMessage;
    const court = props.court;
    const balance = props.balance;
    const { register, getValues, setValue } = useForm();
    const [phone, setPhone] = useState();

    const handleExpChange = (e) => {
    }

    const handlePhoneChange = (values) => {
        const val = values.value;
        setPhone(val && val.length === 10 ? val : null);
    }

    useEffect(() => {
        if (requestData) {
            const form = getValues();
            const errors = validateEpRequest(form, phone);
            if (errors) {
                setErrorMessage(`Please correct the following errors before proceeding: ${errors}`);
            } else setData(getEpRequest(form, balance));
        }
    }, [requestData])

    useEffect(() => {
        if (balance) {
            setValue('caseNumber', balance.caseNumber);
            let name = balance.partyName;
            if (name.includes(',')) {
                const idx = name.indexOf(',');
                name = (name.substring(idx + 1).trim() + ' ' + name.substring(0, idx).trim());
            }
            setValue('defendantName', name);
        }
    }, [balance])

    return (
        <Grid container spacing={2} alignItems='top' >
            <Typography variant='body2' component='p' sx={{...classes.title, margin: '0.5rem 1rem 1rem 1rem'}}>
                Please provide the required information below in order to process your traffic school program application at {court.courtName}.
            </Typography>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='caseNumber' fullWidth sx={classes.formControl} {...register('caseNumber')}>
                    <FormLabel htmlFor='caseNumber' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Case Number
                    </FormLabel>
                    <TextField id='caseNumber' name='caseNumber' variant='outlined' fullWidth autoComplete='off' inputProps={{maxLength: 50, sx: classes.textbox, "aria-required": "true"}} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='defendantName' fullWidth sx={classes.formControl} {...register('defendantName')}>
                    <FormLabel htmlFor='defendantName' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Defendant Name
                    </FormLabel>
                    <TextField id='defendantName' name='defendantName' variant='outlined' fullWidth autoComplete='off' inputProps={{maxLength: 150, sx: classes.textbox, "aria-required": "true"}} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='plea' fullWidth sx={classes.formControl} {...register('plea')}>
                    <FormLabel htmlFor='plea' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Plea
                    </FormLabel>
                    <Select
                        id='plea'
                        name='plea'
                        native
                        variant='outlined'
                        fullWidth
                        sx={{height: '2rem'}}
                        inputProps={{
                            "aria-required": "true"
                        }}
                    >
                        <option key='none' value=''>Select a plea to enter</option>
                        <option key='guilty' value='Guilty'>Guilty</option>
                        <option key='nocontest' value='No Contest'>No Contest</option>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl  name='address' fullWidth sx={classes.formControl} {...register('address')}>
                    <FormLabel htmlFor='address' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Address
                    </FormLabel>
                    <TextField id='address' name='address' variant='outlined' fullWidth autoComplete='off' inputProps={{maxLength: 100, sx: classes.textbox,"aria-required": "true"}} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='city' fullWidth sx={classes.formControl} {...register('city')}>
                    <FormLabel htmlFor='city' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        City
                    </FormLabel>
                    <TextField id='city' name='city' variant='outlined' fullWidth autoComplete='address-level2' inputProps={{maxLength: 100, sx: classes.textbox, "aria-required": "true"}} />
                </FormControl>
            </Grid>
            <Grid item xs={5} sm={2} md={2}>
                <FormControl name='state' fullWidth sx={classes.formControl} {...register('state')}>
                    <FormLabel htmlFor='state' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        State
                    </FormLabel>
                    <Select
                        id='state'
                        name='state'
                        native
                        variant='outlined'
                        fullWidth
                        sx={{height: '2rem'}}
                        inputProps={{
                            "aria-required": "true"
                        }}
                    >
                        <option key='none' value=''>Enter your state</option>
                        {statesAbbr.map((state) => (
                            <option key={state.key} value={state.value} style={{fontSize: '.9rem'}}>{state.text}</option>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={7} sm={4} md={2}>
                <FormControl name='zip' fullWidth sx={classes.formControl} {...register('zip')}>
                    <FormLabel htmlFor='zip' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Zip
                    </FormLabel>
                    <PatternFormat
                        id='zip'
                        name='zip'
                        customInput={TextField}
                        type='text'
                        autoComplete='postal-code'
                        variant='outlined'
                        format='#####'
                        InputProps={{
                            style: classes.numberbox,
                            inputProps: {
                                "aria-required": "true"
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='email' fullWidth sx={classes.formControl} {...register('email')}>
                    <FormLabel htmlFor='email' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Email Address
                    </FormLabel>
                    <TextField id='email' name='email' variant='outlined' fullWidth autoComplete='off' inputProps={{maxLength: 150, sx: classes.textbox, "aria-required": "true"}} />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FormControl name='phone' fullWidth sx={classes.formControl} {...register('phone')}>
                    <FormLabel htmlFor='phone' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Phone Number
                    </FormLabel>
                    <PatternFormat
                        id='phone'
                        name='phone'
                        customInput={TextField}
                        type='text'
                        autoComplete='tel-national'
                        variant='outlined'
                        format="(###) ###-####"
                        onValueChange={handlePhoneChange}
                        InputProps={{
                            style: classes.numberbox,
                            inputProps: {
                                "aria-required": "true"
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
                <FormControl name='license' fullWidth sx={classes.formControl} {...register('license')}>
                    <FormLabel htmlFor='license' shrink={true} required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Driver License
                    </FormLabel>
                    <TextField id='license' name='license' variant='outlined' fullWidth autoComplete='off' inputProps={{maxLength: 50, sx: classes.textbox, "aria-required": "true" }} />
                </FormControl>
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
                <FormControl name='expires' fullWidth sx={classes.formControl} {...register('expires')}>
                    <FormLabel shrink={true} htmlFor='expires' required sx={{...classes.inputLabel, paddingTop: '0', marginTop: '0'}}>
                        Expires
                    </FormLabel>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            name='expires'
                            disableMaskedInput={false}
                            format='MM/dd/yyyy'
                            defaultValue={new Date()}
                            onChange={handleExpChange}
                            slotProps={{
                                textField: {
                                    id: 'expires',
                                    inputProps: {
                                        sx: classes.textbox,
                                        "aria-required": "true"
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default EpPlea;
